import React from 'react';
import { Handle, Position } from '@xyflow/react';

export default function TagNode({ data, selected }) {
  const { tag } = data;
  return (
    <div
      className={`card ${selected ? 'border-primary' : ''}`}
      style={{ width: 180, cursor: 'pointer' }}
    >
      <Handle type="target" position={Position.Top} />
      <div className="card-body p-2 text-center">
        <div className="small fw-semibold text-truncate" title={tag.name}>
          {tag.is_system && <i className="bi bi-lock-fill me-1" title="Global (locked)" />}
          {tag.name}
        </div>
        <div className="text-muted" style={{ fontSize: '0.7rem' }}>
          {tag.asset_count ?? 0} asset{tag.asset_count === 1 ? '' : 's'}
        </div>
      </div>
      <Handle type="source" position={Position.Bottom} />
    </div>
  );
}
